import { render, staticRenderFns } from "./AccountSettingsEditEmailForm.vue?vue&type=template&id=135d4d36&"
import script from "./AccountSettingsEditEmailForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsEditEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports